import React from 'react';
import configServ from '../../services/config';
import { Box, Typography, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useDispatch, useSelector } from 'react-redux';
import { rSetFetchGstTracking } from '../../redux/reducers/GlobalVariables';

const GstTracker = () => {
    const [gstData, setGstData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const dispatch = useDispatch();
    const {
        company_id,
        gstTracking,
      } = useSelector((state) => state.GlobalVariables);

    const fetchGstData = async () => {
        try {
            setLoading(true);
            const response = await configServ.getAllGstTracking(company_id);
            if (response.status) {
                // API response se seedha array extract kar rahe hain
                const data = response.data || [];
                setGstData(data);
            }
        } catch (error) {
            console.error('Error fetching GST data:', error);
        }finally{
            setLoading(false);
            dispatch(rSetFetchGstTracking(false)); // Redux state ko update kar rahe hain
        }
    };

    React.useEffect(() => {
       
            fetchGstData();
      
    }, [gstTracking]);

    // Sirf wahi invoices filter karenge jinka JSON download ho chuka hai par IRN pending hai
    const pendingInvoices = gstData.filter(item => item.status === "JSON_DOWNLOADED" && !item.irn_uploaded_at);

    // Agar koi pending invoice nahi hai, toh banner nahi dikhega
    if (pendingInvoices.length === 0) return null;

    console.log("gstTracking", gstTracking)

    return (
        <Paper
            elevation={0}
            sx={{
                background: 'linear-gradient(90deg, #fff5f5 0%, #ffebee 100%)',
                border: '1px solid #ffcdd2',
                borderRadius: 2,
                p: 1.5,
                mb: 3,
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden', // Taki text container se bahar na nikle
                position: 'relative'
            }}
        >
            {/* Left side fixed alert badge taaki user ko context hamesha dikhe */}
            <Box 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    bgcolor: '#d32f2f', 
                    color: '#fff', 
                    px: 2, 
                    py: 0.5, 
                    borderRadius: 1.5, 
                    zIndex: 2,
                    boxShadow: '2px 0px 10px rgba(211, 47, 47, 0.2)',
                    mr: 2,
                    whiteSpace: 'nowrap'
                }}
            >
                <ErrorOutlineIcon fontSize="small" sx={{ mr: 1 }} />
                <Typography variant="body2" fontWeight="600">
                    PENDING IRN
                </Typography>
            </Box>

            {/* Right to Left Scrolling Container */}
            <Box 
                sx={{ 
                    overflow: 'hidden', 
                    width: '100%', 
                    display: 'flex', 
                    alignItems: 'center',
                    zIndex: 1
                }}
            >
                <Box
                    sx={{
                        display: 'inline-flex',
                        whiteSpace: 'nowrap',
                        gap: 4, // Har invoice alert ke beech ka gap
                        animation: 'marquee 25s linear infinite',
                        '&:hover': {
                            animationPlayState: 'paused' // Mouse le jaane par scroll ruk jayega taaki user aaram se padh sake
                        },
                        '@keyframes marquee': {
                            '0%': { transform: 'translateX(100%)' },
                            '100%': { transform: 'translateX(-100%)' }
                        }
                    }}
                >
                    {pendingInvoices.map((item) => (
                        <Typography 
                            key={item.id} 
                            variant="body2" 
                            sx={{ 
                                color: '#c62828', 
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                bgcolor: 'rgba(211, 47, 47, 0.04)',
                                px: 1.5,
                                py: 0.5,
                                borderRadius: 1,
                                border: '1px dashed rgba(211, 47, 47, 0.2)'
                            }}
                        >
                            ⚠️ Invoice <strong style={{ marginLeft: '4px', marginRight: '4px', color: '#b71c1c' }}>{item.invoice?.invoice_number}</strong>: JSON downloaded, but IRN file upload is pending.
                        </Typography>
                    ))}
                </Box>
            </Box>
        </Paper>
    );
};

export default GstTracker;